import * as React from "react";
import { Calendar } from '@progress/kendo-react-dateinputs';

export const Date = () => {
   return  <div className="date-container">
       <Calendar />
   </div>
}